var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    viewBox: "10.15 -0.03 84.42 99.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.186,99.647H12.147c-1.1,0-2-0.9-2-2V2.11c0-1.1,0.9-2,2-2h11.039c1.1,0,2,0.9,2,2v95.536  C25.186,98.747,24.286,99.647,23.186,99.647z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.093,99.647H29.209c-1.1,0-2-0.9-2-2V16.179c0-1.1,0.9-2,2-2h10.884c1.1,0,2,0.9,2,2v81.467  C42.093,98.747,41.193,99.647,40.093,99.647z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.843,99.647H45.96c-1.1,0-2-0.9-2-2V1.973c0-1.1,0.9-2,2-2h10.884c1.1,0,2,0.9,2,2v95.674  C58.843,98.747,57.943,99.647,56.843,99.647z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.137,96.569L82.71,99.688c-1.054,0.315-2.174-0.289-2.489-1.343L60.01,30.786c-0.315-1.054,0.289-2.174,1.343-2.489  l10.427-3.119c1.054-0.315,2.174,0.289,2.489,1.343L94.48,94.08C94.795,95.133,94.191,96.254,93.137,96.569z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon-book.7845ae1de575b27ea23d0ea3dda889c6.svg";
export { ForwardRef as ReactComponent };